import { memo } from 'react';
import { Picture } from '@ui';
import {
  promocodeBannerLeaf,
  appBannerPhone,
  appBannerCaviar,
  appBannerLeaf,
  appStoreSmall,
  huaweiSmall,
  googlePlaySmall
} from '@images';
import { APP_STORE, GOOGLE_PLAY, HUAWEI_STORE } from '@constants/appLinks';
import './NewAppBanner.scss';

const NewAppBanner = () => (
  <div className='new-app-banner'>
    <Picture
      pictureClassName={'new-app-banner__image new-app-banner__iphone'}
      icon={appBannerPhone}
      width='414'
      height='709'
      alt='phone'
    />
    <Picture
      pictureClassName={'new-app-banner__image new-app-banner__caviar'}
      icon={appBannerCaviar}
      width='213'
      height='109'
      alt='caviar'
    />
    <Picture
      pictureClassName={'new-app-banner__image new-app-banner__leaf'}
      icon={appBannerLeaf}
      width='75'
      height='72'
      alt='leaf'
    />
    <Picture
      pictureClassName={'new-app-banner__image new-app-banner__leaf2'}
      icon={promocodeBannerLeaf}
      width='83'
      height='82'
      alt='phone'
    />
    <div className='new-app-banner__title'>
      500 ₽ на первый заказ <br />
      <span className='new-app-banner__title__desc'>
        из приложения от 2 999 ₽
      </span>
    </div>
    <div className='new-app-banner__text'>
      Промокод <span className='new-app-banner__text__bold'>NEW500</span>
    </div>
    <div className='new-app-banner__btns'>
      <a href={APP_STORE} target='_blank' rel='noreferrer'>
        <Picture icon={appStoreSmall} width='40' height='40' alt='appStore' />
      </a>
      <a href={GOOGLE_PLAY} target='_blank' rel='noreferrer'>
        <Picture
          icon={googlePlaySmall}
          width='40'
          height='40'
          alt='google play'
        />
      </a>
      <a href={HUAWEI_STORE} target='_blank' rel='noreferrer'>
        <Picture icon={huaweiSmall} width='40' height='40' alt='google play' />
      </a>
    </div>
  </div>
);

export default memo(NewAppBanner);
